import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Result } from '../../shared/result';
import { map } from 'rxjs/operators';
import { ImportUserMaster } from '../route-master/Model/user-master';

const CREATE_ACTION = 'InsertUpdateDeleteUserMaster';
const UPDATE_ACTION = 'InsertUpdateDeleteUserMaster';
const DELETE_ACTION = 'InsertUpdateDeleteUserMaster';
const EDIT_ACTION = 'InsertUpdateDeleteUserMaster';

@Injectable({
  providedIn: 'root'
})



export class UserMasterService {


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  
  constructor(private http: HttpClient) { }

  public InsertImportUserMaster(data:ImportUserMaster) {

    return this.http.post<Result>(environment.apiUrl +`/RoleManagement/InsertImportUserMaster`,data, this.httpOptions);
  }
  public  DownloadFile(data:any) {    
    const headers = new HttpHeaders()
    .set('Accept', 'application/xlsx; charset=utf-8');
    return   this.http.post(environment.apiUrl + `/RoleManagement/DownloadMasterFile`, data,
    { headers, observe: 'response', responseType: 'blob' }
    );
  }
  public GetAll(data: any) {
    return this.http.post<Result>(`${environment.apiUrl}/RoleManagement/GetUserMaster`, data);
  }

  public Save(data: any, isNew?: boolean) {
    const action = isNew ? CREATE_ACTION : UPDATE_ACTION;
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/${action}`, data)
      .pipe(map(user => {
        return user;
      }));
  }
  public Delete(data: any) {
    const action = DELETE_ACTION;
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/DeleteUser`, data)
      .pipe(map(user => {
        return user;
      }));
  }
  public update(data: any) {
    const action = EDIT_ACTION;
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/${action}`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  public GetRegionalLanguage() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetRegionalLanguageMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }

  public GetUserTypeMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/UserTypeMaster/GetUserTypeMasterDropDown`, '')
      .pipe(map(value => {
        return value;
      }));
  }

  public GetRoleMaster(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/RoleManagement/GetRoleMasterForDropDownByUser`, data)
      .pipe(map(value => {
        return value;
      }));
  }

  public GetDesignationMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetDesignationMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }
  public GetDepartmentMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetDepartmentMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }
  public GetOrganizationEntityMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetOrganizationEntityMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }
  public GetGeoStructure() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetGeoStructure`, '')
      .pipe(map(value => {
        return value;
      }));
  }

  public GetIDProofMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetIDProofMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }
  public containsItem(chkKey: any[], item: any): boolean {
    return chkKey.indexOf(item['intOrganizationEntityID']) > -1;
  }

  public isIndeterminate(chkKey: any[], items: any[] = []): boolean {
    let idx = 0;
    let item;

    while (item = items[idx]) {
      if (this.isIndeterminate(item.items) || this.containsItem(chkKey, item)) { return true; }
      idx += 1;
    }
    return false;
  }
  public GetOrganizationEntityTree() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetOrganizationEntityTree`, '')
      .pipe(map(user => {
        return user;
      }));
  }

  public GetSTDCodeMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetSTDCodeMaster`, '')
      .pipe(map(value => {
        return value;
      }));
  }

  UpdateUserDetail(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/UploadUserFile`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  UpdateLetterDetails(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/UploadLetterFile`, data)
      .pipe(map(user => {
        return user;
      }));
  }

  UpdateOfficialOrderDetail(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/RoleManagement/UploadOfficialOrderFile`, data)
      .pipe(map(user => {
        return user;
      }));
  }
  // public GetCorporationList(data) {    
  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetCorporation`, data)
  //     .pipe(map(value => {
  //       return value;
  //     }));
  // }

  // public GetZoneList(data) {    
  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetZoneOrCluster`, data)
  //     .pipe(map(value => {
  //       return value;
  //     }));
  // }

  // public GetDivisionList(data) {    
  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetDivisionOrDistrict_Multi`, data)
  //     .pipe(map(value => {
  //       return value;
  //     }));
  // }

  // public GetDepotList(data) {    
  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetDepotOrBlock_Multi`, data)
  //     .pipe(map(value => {
  //       return value;
  //     }));
  // }

  // public GetBookingCenterList(data) {    
  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetBookingCenter_Multi`, data)
  //     .pipe(map(value => {
  //       return value;
  //     }));
  // }

  // public GetAgencyMasterByOrganizationEntityID(data:any) {

  //   return this.http.post<Result>(`${environment.apiUrl}/Common/GetAgencyMasterByOrganizationEntityID`,data, this.httpOptions);
  //   }

  public GetSystemDataList() {
    return this.http.post<Result>(`${environment.apiUrl}/Common/GetSystemDataList`, '')
      .pipe(map(value => {
        return value;
      }));
  }

}
